module.exports = __webpack_public_path__ + "img/14.21826e36.jpg";